import
{
  Component,
  HostListener,
  Input,
  OnChanges,
  SimpleChanges,
} from '@angular/core';
import { ToastService } from '@shared/events/toast.service';
import { ImageTransform, ImageCroppedEvent } from 'ngx-image-cropper';
import { CropReciboService } from './crop-recibo.service';

@Component({
  selector: 'app-crop-recibo',
  templateUrl: './crop-recibo.component.html',
  styleUrls: ['./crop-recibo.component.scss'],
})
export class CropReciboComponent implements OnChanges
{
  @Input() hasError = false;

  aspect = 1;
  rotation = 0;
  options: ImageTransform = {
    scale: 1,
  };

  constructor(
    public cropService: CropReciboService,
    private _toastService: ToastService
  ) { }


  ngOnChanges(changes: SimpleChanges)
  {
    this.hasError = changes.hasError.currentValue;
  }

  @HostListener('dragover', ['$event']) onDragOver(event: DragEvent)
  {
    event.preventDefault();
  }

  @HostListener('drop', ['$event']) onDrop(event: DragEvent)
  {
    event.preventDefault();
    if (event.dataTransfer && event.dataTransfer.files.length > 0)
    {
      const imageChangedEvent = { target: { files: event.dataTransfer.files } };
      this.cargarImagen(imageChangedEvent);
    }
  }
  cargarImagen(event: any)
  {
    this.hasError = false;
    const fileName = event.target.files[0].name;
    const ext = fileName.split('.').pop().toLowerCase();

    if (ext !== 'png' && ext !== 'jpg')
    {
      this._toastService.toastWarning('El archivo no es una Imagen PNG o JPG');
      return;
    }

    if (event.target.files[0].size > 2000000)
    {
      this._toastService.toastWarning('El archivo no debe pesar mas de 2 MB');
      return;
    }

    this.cropService.recibo = event;
    this.cropService.imagen = event;
  }

  cortarImagen(event: ImageCroppedEvent)
  {
    this.cropService.respuesta.imagen = event.base64;
    this.cropService.recibo = event.base64;
  }

  zoom(value: any)
  {
    this.options = {
      ...this.options,
      scale: value.target.value,
    };
  }

  expandir()
  {
    this.options = {
      ...this.options,
      scale: 1,
    };
  }

  rotar()
  {
    this.rotation++;
  }

  borrar()
  {
    this.cropService.imagen = null;
    this.cropService.respuesta.imagen = null;
    this.cropService.recibo = null;
  }
}
